import { Doctor } from '../interfaces/doctors.interface';
import { Action } from 'redux';

export const DOCTOR_STATE_REDUX_ID_SAPPHIRE_DIGITAL = 'Doctors_SAPPHIRE_DIGITAL';

export interface DoctorStateSapphireDigital {
  doctors: Doctor[];
  pcp: Doctor;
}

export class DoctorAction implements Action {
  type: string;
  doctor?: Doctor;
  doctorState?: DoctorStateSapphireDigital;
}

const INITIAL_STATE: DoctorStateSapphireDigital = {
  doctors: [],
  pcp: null
};

export const ADD_DOCTOR = 'ADD_DOCTOR_SAPPHIRE_DIGITAL';
export const REMOVE_DOCTOR = 'REMOVE_DOCTOR_SAPPHIRE_DIGITAL';
export const UPDATE_DOCTORS = 'UPDATE_DOCTORS_SAPPHIRE_DIGITAL';
export const ADD_PCP = 'ADD_PCP_SAPPHIRE_DIGITAL';
export const REMOVE_PCP = 'REMOVE_PCP_SAPPHIRE_DIGITAL';
export const UPDATE_PCP = 'UPDATE_PCP_SAPPHIRE_DIGITAL';
export const RESET_DOC = 'RESET_DOC_SAPPHIRE_DIGITAL';
export const SET_DOCTOR_STATE = 'SET_DOCTOR_STATE_SAPPHIRE_DIGITAL';

export function addDoctor(doctor: Doctor): DoctorAction {
  return { type: ADD_DOCTOR, doctor };
}
export function removeDoctors(doctor: Doctor): DoctorAction {
  return { type: REMOVE_DOCTOR, doctor };
}
export function updateDoctors(doctor: Doctor): DoctorAction {
  return { type: UPDATE_DOCTORS, doctor };
}
export function addPCP(doctor: Doctor): DoctorAction {
  return { type: ADD_PCP, doctor };
}
export function removePCP(doctor: Doctor): DoctorAction {
  return { type: REMOVE_PCP, doctor };
}
export function updatePCP(doctor: Doctor): DoctorAction {
  return { type: UPDATE_PCP, doctor };
}
export function setDoctorState(doctorState: DoctorStateSapphireDigital): DoctorAction {
  return { type: SET_DOCTOR_STATE, doctorState };
}

export function Doctors_SAPPHIRE_DIGITAL( state: DoctorStateSapphireDigital = INITIAL_STATE, action: DoctorAction ) {

  const copiedState: DoctorStateSapphireDigital = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    
    case ADD_DOCTOR:
      copiedState.doctors.push(action.doctor);
      return Object.assign({}, state, copiedState);

    case REMOVE_DOCTOR:
      copiedState.doctors
        = copiedState.doctors.filter( curState => {
          return curState.providerId !== action.doctor.providerId;
        } );
      return Object.assign({}, state, copiedState);

    case UPDATE_DOCTORS:
      copiedState.doctors
        = copiedState.doctors.filter( curState => {
          return curState.providerId !== action.doctor.providerId;
        } );
      copiedState.doctors.push(action.doctor);
      return Object.assign({}, state, copiedState);

    case ADD_PCP:
      copiedState.pcp = action.doctor;
      return Object.assign({}, state, copiedState);

    case REMOVE_PCP:
      copiedState.pcp = null;
      return Object.assign({}, state, copiedState);

    case UPDATE_PCP:
      copiedState.pcp = action.doctor;
      return Object.assign({}, state, copiedState);

    case SET_DOCTOR_STATE:
      return Object.assign({}, state, action.doctorState);

    default:
      return state;
  }
}
